import "./jquery-global.js";
import "jquery-ui/ui/widgets/datepicker";
import "bootstrap"; 

import "./jquery.cascade-countries.js";
import "./fancybox/jquery.fancybox.js";
import {trapFocus} from "./jquery.extra.js";
import "./jquery.number-step.js";
import "./jquery.prettydropdowns.js";
import "./jquery.stylish-select.js";
import "./jquery.unobtrusive-ajax.js";
import { loadPaymentGateway } from '../../Payment/payment-loader.js';   
import 'slick-carousel'; 

//following rsa file has to be strict order 
import "./rsa/jsbn.js";
import "./rsa/prng4.js";
import "./rsa/rng.js";
import "./rsa/rsa.js"; 
import "./rsa/login.js";



import "./datepicker-en-AU.js";
import "./datepicker-en-GB.js";
import "./datepicker-en-NZ.js";
import "./datepicker-ja-JP.js";
 
import "./vii-event-dispatcher.js";

import "./carousel.js"; 
'use strict';

$('.fancybox-skin').each(function () {
    console.log($(this));
    trapFocus($(this));
});
window.loadPaymentGateway = loadPaymentGateway;

